export const SET_USERS= 'SET_USERS';
export const LOAD_COMPANY_USERS= 'LOAD_COMPANY_USERS';
export const SEND_INVITATION= 'SEND_INVITATION';
